import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-italics",
  "use": "icon-italics-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-italics\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<polygon points=\"15 18 7 18 7 16.5 9.89 16.5 11.5 7.5 8 7.5 8 6 16 6 16 7.5 13 7.5 11.39 16.5 15 16.5 15 18\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol